module.exports = __webpack_public_path__ + "static/media/trees-game.b55e67d5.png";